<template>
  <!-- star -->

  <div class="homepage_wrap">
    <!-- 导航栏 -->
    <navBar />
    <!-- banner图 -->
    <div class="banner_nav">
      <!-- banner -->
      <div class="banner_nav_bg">
        <img :src="indexBanner" alt="" />
      </div>
      <!-- title -->
      <div class="banner_title_wrap">
        <div class="banner_title_center">
          <p>{{ title }}</p>
          <div>
            现代化综合服务型第三方物流企业
            <span>·</span>基于供应链的全程物流服务
          </div>
        </div>
      </div>

      <!-- 搜索框 -->
      <div class="bill-number">
        <div class="order">
          <input
            v-model="orderNo"
            type="number"
            placeholder="您可以输运单号进行查询"
            class="order-no"
          />
          <button type="button" class="submit-button" @click="searchOrder">
            马上查单
          </button>
        </div>
        <div class="order-note" />
      </div>
    </div>
    <!-- 最新资讯 -->
    <div class="news">
      <div class="news_cont">
        <div class="news_cont_top">
          <h1>最新资讯</h1>
        </div>
        <div class="news_cont_down">
          <!-- left -->
          <div class="news_cont_left">
            <div class="news_bg">
              <div class="news_cont_left_img">
                <img src="../assets/img/news_img1.png" alt="" />
              </div>
              <div class="news_cont_left_text" v-if="newListTop"  @click="newsArticle(newListTop.id)">
                <h1>{{ newListTop.title }}</h1>
                <p>{{ newListTop.add_time }}</p>
                <p>{{ newListTop.synopsis }}</p>
              </div>
            </div>
          </div>
          <!-- right -->
          <div class="news_cont_right">
            <div class="news_cont_right_ul">
              <ul>
                <router-link to="/news">
                  <li>公司新闻</li>
                </router-link>
              </ul>
            </div>
            <div class="news_cont_right_text">
              <div
                  v-for="(item, index) in newList"
                  :key="index"
                  class="news_cont_right_text_item news_cont_right_text_hr"
                  @click="newsArticle(item.id)"
              >
                <h1>{{ item.title }}</h1>
                <p>{{ item.add_time }}</p>
                <p>
                  {{ item.synopsis }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 关于企业 -->
    <div class="AboutEnterprises">
      <div class="AboutEnterprises_cont">
        <!-- top -->
        <div class="AboutEnterprises_cont_top">
          <!-- top_left -->
          <div class="AboutEnterprises_cont_top_left">
            <h1>关于企业</h1>
            <div v-html="aboutCompany && aboutCompany.content" class="AboutEnterprises_content">
            </div>
            <router-link to="/company">
              <div class="AboutEnterprises_cont_top_left_btn">
                <span>了解更多</span>
                <img src="../assets/img/guanyujiantou.png" alt="" />
              </div>
            </router-link>
          </div>
          <!-- top_right -->
          <div class="AboutEnterprises_cont_top_right">
            <img :src="aboutCompany && aboutCompany.image_input[0]" alt="" />
            <div />
          </div>
        </div>
        <!-- bottom -->
        <stat />
      </div>
    </div>

    <!-- footer -->
    <footer2 />

    <!-- end -->
  </div>
</template>

<script>

import footer2 from "../components/footer.vue";
import stat from "../components/stat.vue";


export default {
  name: "Index",
  components: {
    footer2,
    stat,
  },
  data() {
    return {
      indexBanner: '',
      siteLogo:'',
      newListTop:[],
      newList: [],
      orderNo: "",
      aboutCompany:''
    };
  },
  computed: {
    title() {
      return this.$store.state.title;
    },
  },
  created() {
    this.siteInfo = this.commFunc.getSession('setSiteInfoByStore')
    this.getNewsList();
    this.aboutUs();
  },
  methods: {
    getNewsList()  {
      let params = {
        page:1,
        limit:4
      }
      this.reqApi.getTopNews(params,(res) => {
        console.log('新闻列表',res);
          this.newListTop = res[0];
          this.newList = res.slice(1);
      },(err)=>{
        console.log(err)
      })
    },
    aboutUs() {
      this.reqApi.getCompanyInfo(null,(res)=>{
        console.log('关于我们',res);
        this.aboutCompany = res
      },(err)=>{
        //业务错误返回
        console.log(err)
      })
    },
    searchOrder() {
      // alert(this.orderNo);
      this.$router.push({ path: "/search", query: { orderNo: this.orderNo } });
    },
    newsArticle(index) {
      this.$router.push({ path: "/newsDetail", query: { newsId: index } });
    }
  },
};
</script>
<style scoped>
@charset "utf-8";
.homepage_wrap {
  width: 100vw;
  margin: 0 auto;
  height: 1000px;
}

.banner_nav {
  width: 100vw;
  position: relative;
}

.banner_nav_bg img {
  /* 文本居顶部对齐 */
  width: 100%;
  vertical-align: top;
}

/* 导航部分 */
.nav_wrap {
  position: absolute;
  border-radius: 50px;
  margin-top: 50px;
}

/* title */

.banner_title_wrap {
  width: 100%;
  position: absolute;
  bottom: 290px;
  /* border: 1px solid yellow; */
}

.banner_title_center {
  /* border: 1px solid white; */
  text-align: center;
  width: 1200px;
  margin: 0 auto;
  font-size: 90px;
  font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
  font-weight: bold;
  color: #ffffff;
  line-height: 124px;
  letter-spacing: 1px;
}

.banner_title_center div {
  padding-top: 14px;
  font-size: 20px;
  font-family: Helvetica;
  line-height: 24px;
  letter-spacing: 4px;
}

.banner_title_center div span {
  margin: 0 18px;
}
/* news */
.news {
  width: 100vw;
  /*height: 801px;*/
  /*padding-bottom: 30px;*/
  background: #f8f8f8;
}
.news_bg{
  padding-top: 60px;
}
.news_cont {
  margin: 0 auto;
  display: flex;
  flex-flow: column;
  margin: 0 50px;
}
.news_cont_top {
  display: flex;
  flex-flow: row;
  /*justify-content: flex-start;*/
  margin-top: 60px;
}
.news_cont_down{
  display: flex;
  flex-flow: row;
  /*justify-content: center;*/
}
.news_cont_left {
  /*margin-top: 89px;*/
  margin-right: 30px;
}
.news_cont_left_img img {
  /*width: 588px;*/
  height: 353px;
  /*margin-top: 41px;*/
}
.news_cont_left_text {
  padding: 27px 0 36px 40px;
  /*width: 548px;8*/
  height: 150px;
  background-color: #ffffff;
}
.news_cont_left_text h1 {
  font-size: 18px;
  font-weight: 500;
  color: #23337f;
}
.news_cont_left_text p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #8f8f8f;
  margin-top: 10px;
}
.news_cont_right {
  /*width: 588px;*/
  display: flex;
  flex-flow: column;
}
.news_cont_right_ul{
  height: 60px;
}
.news_cont_right_ul ul {
  font-size: 16px;
  font-weight: 400;
  color: #b3b3b3;
  line-height: 22px;
  float: right;
  display: flex;
}
.news_cont_right_ul ul a {
  font-size: 16px;
  font-weight: 400;
  color: #b3b3b3;
  line-height: 22px;
  float: right;
  display: flex;
}
.news_cont_right_ul ul li:hover {
  color: #23337f;
}
.news_cont_right_ul ul span {
  margin: 0 23px 0 24px;
}
.news_cont_right_text {
  /*width: 588px;*/
  /*height: 535px;*/
  background: #ffffff;
}
.news_cont_right_text_item {
  padding: 36px;
}
.news_cont_right_text_item h1 {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #444444;
  line-height: 25px;
}
.news_cont_right_text_item p {
  margin-top: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #8f8f8f;
  line-height: 20px;
}
.news_cont_right_text_hr {
  /* float: right; */
  /*width: 508px;*/

  border-bottom: 1px solid #d7d7d7;
}
.news_cont_right_text_hr:nth-of-type(3) {
  /* float: right; */
  /*width: 508px;*/

  border-bottom: none;
}
.news_cont_right_text_item2 {
  padding: 24px 40px;
}
.news_cont_right_text_item2 h1 {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #444444;
  line-height: 25px;
}
.news_cont_right_text_item2 p {
  margin-top: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #8f8f8f;
  line-height: 20px;
}

/* 关于企业 */
.AboutEnterprises {
  width: 100vw;
  height: 856px;
  background-image: url("../assets/img/guanyu_bg.png");
}
.AboutEnterprises_cont {
  width: 1200px;
  margin: 0 auto;
  height: 100%;
}
.AboutEnterprises_cont_top {
  display: flex;
  justify-content: space-between;
}
.AboutEnterprises_cont_top_left {
  margin-top: 143px;
  width: 600px;
}
.AboutEnterprises_cont_top_left > h1 {
  font-size: 36px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 50px;
}
/*.AboutEnterprises_cont_top_left p {
  margin-top: 36px;

  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 40px;
}*/
.AboutEnterprises_content{
  margin-top: 36px;

  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 40px;
}
.AboutEnterprises_cont_top_left_btn {
  width: 160px;
  height: 40px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  margin-top: 81px;
  display: flex;
  align-items: center;
}
.AboutEnterprises_cont_top_left_btn img {
  width: 24px;
  height: 24px;

  margin-left: 8px;
}
.AboutEnterprises_cont_top_left_btn span {
  margin-left: 32px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
}
.AboutEnterprises_cont_top_right {
  position: relative;
  width: 487px;
  height: 517px;
  margin-top: 115px;
}
.AboutEnterprises_cont_top_right img {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
}
.AboutEnterprises_cont_top_right Div {
  width: 317px;
  height: 408px;
  background: #3491e5;
  position: absolute;
  top: 64px;
  left: -33px;
}

.bill-number {
  position: absolute;
  bottom: 1rem;
  left: 25%;
  background-color: #fff;
  z-index: 10;
  border-radius: 10px;
  /* width: 3.44rem; */
  padding: 0px 10px 10px 10px;
  width: 50%;
}
.bill-number .order {
  padding: 1rem 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bill-number .order-no {
  border: 1px solid #c9c5c5;
  font-size: 1rem;
  padding: 20px 0 20px 10px;
  border-radius: 10px 0px 0px 10px;
  width: 85%;
}

input button {
  width: 100%;
  border: 1px solid var(--old-gray);
  box-sizing: border-box;
  -webkit-appearance: none;
  outline: none;
  border-radius: 0;
  background: none;
  font: 0.12rem/1.5
    '"PingFang SC","Source Han Sans","微软雅黑","microsoft yahei","HanHei SC",PingHei,sans-serif';
}

.bill-number .order-btn {
  padding: 0rem 0.5rem;
}

.bill-number .submit-button {
  width: 15%;
  border-radius: 0px 10px 10px 0px;
  padding: 20px 0px;
  background: red;
  color: #fff;
  border: 1px solid;
  text-align: center;
  font-size: 14px;
}
</style>
